module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/breeno-phone-15.43a27853.png";